import React, { useState } from "react";

export function StarDisplay({ rating, total, size = 16 }) {
  if (!rating) return null;
  return (
    <div style={{display:"flex",alignItems:"center",gap:4}}>
      <div style={{display:"flex",gap:1}}>
        {[1,2,3,4,5].map(star => (
          <span key={star} style={{fontSize:size,color: star<=Math.round(rating)?"#f59e0b":"#ddd"}}>★</span>
        ))}
      </div>
      <span style={{fontSize:size-2,color:"#888",fontWeight:500}}>
        {rating} {total !== undefined && `(${total})`}
      </span>
    </div>
  );
}

export function StarPicker({ value, onChange }) {
  const [hover, setHover] = useState(0);
  return (
    <div style={{display:"flex",gap:4}}>
      {[1,2,3,4,5].map(star => (
        <span
          key={star}
          style={{fontSize:36,cursor:"pointer",color: star<=(hover||value)?"#f59e0b":"#ddd",transition:"color 0.1s"}}
          onMouseEnter={() => setHover(star)}
          onMouseLeave={() => setHover(0)}
          onClick={() => onChange(star)}
        >
          ★
        </span>
      ))}
    </div>
  );
}
